import { TableEmptyState } from '@practium/ui';
import type { Hierarchy, HierarchyLevel } from '../../../types';
import styles from '../SystemTable.module.css';

const resolveGroupName = (level: HierarchyLevel): string => {
	if (!level.group) return '—';
	if (typeof level.group === 'object') return level.group.name;
	return level.group;
};

interface HierarchiesTableProps {
	hierarchies: Hierarchy[];
	onRowClick?: (id: string) => void;
}

export const HierarchiesTable = ({ hierarchies, onRowClick }: HierarchiesTableProps) => {
	if (hierarchies.length === 0) {
		return (
			<TableEmptyState
				title="Nenhuma hierarquia encontrada"
				subtitle="Adicione uma hierarquia para começar"
			/>
		);
	}

	return (
		<div className={styles.tableWrapper}>
			<table className={styles.table}>
				<thead className={styles.thead}>
					<tr>
						<th>Nome</th>
						<th>Nível 1</th>
						<th>Nível 2</th>
						<th>Nível 3</th>
						<th>Nível 4</th>
					</tr>
				</thead>
				<tbody className={styles.tbody}>
					{hierarchies.map(item => (
						<tr
							key={item._id}
							onClick={() => onRowClick?.(item._id)}
							className={onRowClick ? styles.clickableRow : undefined}
						>
							<td>
								<span className={styles.cellPrimary}>{item.name}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{resolveGroupName(item.farmer)}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{resolveGroupName(item.consultant)}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{resolveGroupName(item.company)}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{resolveGroupName(item.master)}</span>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};
